import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import {
  FulfillmentOrderAddress,
  VerifiedAddress,
} from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export function addressesAreDifferent(
  address1: FulfillmentOrderAddress | VerifiedAddress | null | undefined,
  address2: FulfillmentOrderAddress | VerifiedAddress | null | undefined,
) {
  if (!address1 || !address2) {
    return false;
  }

  const normalizeStreetSuffix = (address: string | undefined) => {
    if (!address) {
      return "";
    }
    const normalized = address
      .toLowerCase()
      .replace(/\bdrive\b/g, "dr")
      .replace(/\bstreet\b/g, "st")
      .replace(/\bavenue\b/g, "ave")
      .replace(/\broad\b/g, "rd")
      .replace(/\bboulevard\b/g, "blvd")
      .replace(/\blane\b/g, "ln")
      .replace(/\bplace\b/g, "pl")
      .replace(/\bcourt\b/g, "ct")
      .replace(/\bcircle\b/g, "cir")
      .replace(/\bcove\b/g, "cv")
      .replace(/\bsouth\b/g, "s")
      .replace(/\beast\b/g, "e")
      .replace(/\bwest\b/g, "w")
      .replace(/\bnorth\b/g, "n");
    return normalized;
  };

  const normalizeStateCode = (state: string | undefined) => {
    if (!state) {
      return "";
    }
    const stateMap: { [key: string]: string } = {
      alabama: "AL",
      alaska: "AK",
      arizona: "AZ",
      arkansas: "AR",
      california: "CA",
      colorado: "CO",
      connecticut: "CT",
      delaware: "DE",
      florida: "FL",
      georgia: "GA",
      hawaii: "HI",
      idaho: "ID",
      illinois: "IL",
      indiana: "IN",
      iowa: "IA",
      kansas: "KS",
      kentucky: "KY",
      louisiana: "LA",
      maine: "ME",
      maryland: "MD",
      massachusetts: "MA",
      michigan: "MI",
      minnesota: "MN",
      mississippi: "MS",
      missouri: "MO",
      montana: "MT",
      nebraska: "NE",
      nevada: "NV",
      "new hampshire": "NH",
      "new jersey": "NJ",
      "new mexico": "NM",
      "new york": "NY",
      "north carolina": "NC",
      "north dakota": "ND",
      ohio: "OH",
      oklahoma: "OK",
      oregon: "OR",
      pennsylvania: "PA",
      "rhode island": "RI",
      "south carolina": "SC",
      "south dakota": "SD",
      tennessee: "TN",
      texas: "TX",
      utah: "UT",
      vermont: "VT",
      virginia: "VA",
      washington: "WA",
      "west virginia": "WV",
      wisconsin: "WI",
      wyoming: "WY",
    };
    const normalized = stateMap[state.toLowerCase()] || state;
    return normalized.toLowerCase();
  };

  return (
    normalizeStreetSuffix(address1.address1 || "") !==
      normalizeStreetSuffix(address2.address1 || "") ||
    normalizeStreetSuffix(address1.address2 || "") !==
      normalizeStreetSuffix(address2.address2 || "") ||
    (address1.city || "").toLowerCase() !==
      (address2.city || "").toLowerCase() ||
    normalizeStateCode(address1.province || "") !==
      normalizeStateCode(address2.province || "") ||
    address1.zip?.slice(0, 5).toLowerCase() !==
      address2.zip?.slice(0, 5).toLowerCase() ||
    address1.countryCode?.toLowerCase() !== address2.countryCode?.toLowerCase()
  );
}

export function formatAddress(
  address: FulfillmentOrderAddress | VerifiedAddress | null | undefined,
) {
  if (!address) {
    return "";
  }

  const formattedAddress = `${address.address1}\n${address.address2 ? `${address.address2}\n` : ""}${address.city} ${address.province} ${address.zip} ${address.countryCode}`;
  return formattedAddress;
}

export const AddressVerificationCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Address verification",
    cell: (row) => {
      const verified = row.verifiedDestinationAddress?.verified;
      const different = addressesAreDifferent(
        row.destinationAddress,
        row.verifiedDestinationAddress,
      );
      if (verified && different) {
        return "Verified (Modified)";
      } else if (verified) {
        return "Verified";
      } else {
        return "Not Verified";
      }
    },
  };
